import { Text } from '../../../components/general/Text';
import { VehicleConnectionIndicator } from '../../../components/general/VehicleConnectionIndicator';
import type { VehicleId } from '../../../types/gcs/vehicle';
import { getShortVehicleId } from '../../../utils/formatters';
import { SidePanelVehicleTelemetryTile } from './SidePanelTelemetryTile';
import VehicleStatusTile from './VehicleStatusTile';
import { useFailureModeBlinkEffect } from '../../../hooks/useFailureModeBlinkEffect';

interface SidePanelVehicleTileProps {
  gcsId: string;
  vehicleId: VehicleId;
  isSelected: boolean;
  onPress: () => void;
}

export const SidePanelVehicleTile = ({ gcsId, vehicleId, isSelected, onPress }: SidePanelVehicleTileProps) => {
  const vehicleLabel = getShortVehicleId(vehicleId);
  const { isBlinking, showRedBackground } = useFailureModeBlinkEffect(gcsId, vehicleId);

  const getBackgroundColor = () => {
    if (isBlinking && showRedBackground) {
      return '#ffcccc'; // Light red
    }
    return isSelected ? '#e3e3e3' : '#ffffff';
  };

  const getHoverBackgroundColor = () => {
    if (isBlinking && showRedBackground) {
      return '#ffb3b3'; // Slightly darker red on hover
    }
    return isSelected ? '#b2b2b2' : '#dfdfdf';
  };

  return (
    <li
      onClick={onPress}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = getHoverBackgroundColor();
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = getBackgroundColor();
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        gap: '8px',
        cursor: 'pointer',
        backgroundColor: getBackgroundColor()
      }}
    >
      <Text
        variant='body3-bold'
        style={{
          width: '32px',
          flexShrink: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          textAlign: 'left'
        }}
      >
        {vehicleLabel}
      </Text>
      <VehicleStatusTile gcsId={gcsId} vehicleId={vehicleId} />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <VehicleConnectionIndicator gcsId={gcsId} vehicleId={vehicleId} />
      </div>
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
        <SidePanelVehicleTelemetryTile gcsId={gcsId} vehicleId={vehicleId} />
      </div>
    </li>
  );
};
